import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from 'react';
import { Children } from 'react';
import { ActionLabel } from './ActionLabel';
import { joinClassNames } from './themeClassNames';

type BrandButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'link' | 'quadrary';
type BrandButtonSize = 'sm' | 'md' | 'lg';

interface BrandActionStyleProps {
  variant?: BrandButtonVariant;
  size?: BrandButtonSize;
}

type BrandButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & BrandActionStyleProps & {
  children: ReactNode;
};

type BrandLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & BrandActionStyleProps & {
  children: ReactNode;
};

function brandButtonClassName({
  className,
  size,
  variant,
}: {
  className?: string;
  size: BrandButtonSize;
  variant: BrandButtonVariant;
}) {
  return joinClassNames(
    'brand-button brand-focus-ring',
    `brand-button-${variant}`,
    `brand-button-${size}`,
    className,
  );
}

export function BrandButton({
  children,
  className,
  size = 'md',
  type = 'button',
  variant = 'primary',
  ...buttonProps
}: BrandButtonProps) {
  return (
    <button
      {...buttonProps}
      type={type}
      className={brandButtonClassName({ className, size, variant })}
    >
      {Children.map(children, (child) => typeof child === 'string' && child.includes('\n') ? <ActionLabel text={child} /> : child)}
    </button>
  );
}

export function BrandLink({
  children,
  className,
  size = 'md',
  variant = 'primary',
  ...linkProps
}: BrandLinkProps) {
  return (
    <a
      {...linkProps}
      className={brandButtonClassName({ className, size, variant })}
    >
      {Children.map(children, (child) => typeof child === 'string' && child.includes('\n') ? <ActionLabel text={child} /> : child)}
    </a>
  );
}
